import FamilyRegistraion from './components/FamilyRegistration';

export default FamilyRegistraion;
